<template>
  <div class="project-popover-container" v-loading="loading">
    <el-input
      placeholder="搜索项目名称"
      v-model="form.title"
      class="input-search"
      clearable
      prefix-icon="icon iconfont iconicon_search1"
      @input="handleSearch"
    ></el-input>

    <ul v-if="searchList.length" class="search-list" v-infinite-scroll="load">
      <li
        v-for="item of searchList"
        :key="item.project_id"
        @click="handleRouterTo(item.project_id)"
      >
        <div class="item-bg">
          <img :src="getBg(item.background_color || 'blue')" alt="" />
          <span class="icon">{{ textShow(item) }}</span>
        </div>
        <toolTip class="name" :title="item.title">
          <span>{{ item.title }}</span>
        </toolTip>
      </li>
    </ul>

    <nothing v-else-if="searchNoRes" :width="'88px'" :config="{ tip: '暂无此项目' }"></nothing>

    <div class="project-list-wrap">
      <div class="project-list" v-if="starProjectList.length && !searchNoRes">
        <p class="tit">星标项目</p>
        <ul v-infinite-scroll="starListLoad">
          <li
            v-for="item in starProjectList"
            :key="item.project_id"
            @click="handleRouterTo(item.project_id)"
          >
            <div class="item-bg">
              <img :src="getBg(item.background_color || 'blue')" alt="" />
              <span class="icon">{{ textShow(item) }}</span>
            </div>
            <toolTip class="name" :title="item.title">
              <span>{{ item.title }}</span>
            </toolTip>
          </li>
        </ul>
      </div>

      <div class="project-list" v-if="historyProjectList.length && !searchNoRes">
        <p class="tit">最近访问项目</p>
        <ul>
          <li
            v-for="item in historyProjectList"
            :key="item.project_id"
            @click="handleRouterTo(item.project_id)"
          >
            <div class="item-bg">
              <img :src="getBg(item.background_color || 'blue')" alt="" />
              <span class="icon">{{ textShow(item) }}</span>
            </div>
            <toolTip class="name" :title="item.title">
              <span>{{ item.title }}</span>
            </toolTip>
          </li>
        </ul>
      </div>
    </div>

  </div>
</template>

<script>
//api
import api from '@/services/api/home/home'
import apiProject from '@/services/api/project/project'

import { colorArray } from '@/components/colorControl/color'

export default {
  props: {
    // 该组件是否显示
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 搜索无结果
    searchNoRes() {
      return this.form.title && !this.searchList.length && !this.searchIng
    }
  },
  data () {
    return {
      loading: false,
      colorArray: colorArray,
      form: {
        per_page: 10,
        page: 1,
        title: ''
      },
      searchIng: false,
      searchList: [],
      searchListLoadVisible: true,
      starListLoadVisible: true,
      starListForm: {
        page: 1,
        number: 10
      },
      starProjectList: [],
      historyProjectList: [],
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.getStarList() //初始化获取星标项目列表
        this.getHistoryList() //初始化获取访问列表
      } else {
        this.searchList = []
        this.starProjectList = []
        this.historyProjectList = []
      }
    }
  },
  methods: {
    textShow(item) {
      let {title, background_text} = item
      return background_text ? background_text[0] : title[0]
    },
    async init () {
      this.loading = true
      if (!this.form.title) {
        this.loading = false
        return
      }
      const res = await apiProject.getSearchProjects(this.form)
      if (res) {
        if (res.data.length < this.form.per_page) {
          this.searchListLoadVisible = false
        }
        this.searchList.push(...res.data)
        this.loading = false
        this.searchIng = false
      }
    },
    load() {
      if (this.visible && this.form.title && this.searchListLoadVisible) {
        this.$nextTick(() => {
          this.form.page += 1
          this.init()
        })
      }
    },
    handleSearch() {
      this.searchIng = true
      this.debounce(() => {
        this.searchList = []
        this.form.page = 1
        this.init()
      }, 500)
    },
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(fn, wait)
    },
    // 星标项目列表无限加载
    starListLoad() {
      if (this.visible && this.starListLoadVisible) {
        this.starListForm.page += 1
        this.getStarList() //初始化获取星标项目列表
      }
    },
    async getStarList() {
      const res = await api.getprojectMarkStarList(this.starListForm)
      if (res) {
        this.$nextTick(() => {
          if (res.data.length < this.starListForm.number) {
            this.starListLoadVisible = false
          }
          this.starProjectList.push(...res.data)
        })
      }
    },
    async getHistoryList() {
      const res = await api.getProjectBrowseHistoryList()
      if (res) {
        this.$nextTick(() => {
          this.historyProjectList = res.data
        })
      }
    },
    // 获取对应的背景颜色
    getBg(color) {
      let _url = ''
      this.colorArray.find(item => {
        if (item.background_color === color) {
          _url = item.backGroundMini
        }
      })
      return _url
    },
    // 跳往对应的项目
    handleRouterTo(id) {
      this.$emit('handleClose')
      this.$router.push(`/task?projectId=${id}&isTabShow=true`)
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.project-popover-container {
  width: 360px;
  max-height: 610px;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  .input-search {
    border-bottom: 1px solid rgba(32, 32, 32, .08);
    .el-input__inner {
      height: 54px;
      padding-left: 46px;
      border: none !important;
    }
    .el-input__prefix {
      left: 25px;
      .el-input__icon {
        font-size: 14px;
        width: 12px;
        line-height: 54px;
        @include fontColorOpacity(.8);
      }
    }
    .el-input__suffix {
      right: 24px;
    }
  }
  // .nothing-box {
  //   img {
  //     width: 88px;
  //   }
  //   .tip {
  //     margin: 0;
  //   }
  // }
  ul {
    &.search-list {
      width: 328px;
      margin: 0 auto;
      // padding: 0 16px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(32, 32, 32, .08);
    }
    li {
      cursor: pointer;
      width: 100%;
      height: 48px;
      border-radius: 4px;
      margin-bottom: 6px;
      display: flex;
      align-items: center;
      padding-left: 8px;
      box-sizing: border-box;
      border-radius: 4px;
      @include fontColorOpacity(1);
      &:hover {
        @include bgColorOpacity(.04);
      }
      .item-bg {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        margin-right: 19px;
        overflow: hidden;
        position: relative;
        img {
          width: 100%;
          height: 100%;
        }
        .icon {
          position: absolute;
          left: 0;
          top: 0;
          display: block;
          width: 32px;
          height: 32px;
          // background: linear-gradient(225deg, rgba(197,222,255,0.7) 0%, rgba(68,147,255,0.34) 100%);
          // border-radius: 4px;
          font-size: 18px;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.81);
          line-height: 32px;
          text-align: center;
          // margin-right: 19px;
        }
      }
      .name {
        width: 0;
        flex: 1;
      }
    }
  }
  .project-list-wrap {
    height: 0;
    flex: 1;
    overflow-y: scroll;
    .project-list {
      width: 328px;
      margin: 0 auto;
      padding: 0 0 10px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(32, 32, 32, .08);
      .tit {
        margin: 16px 0;
        padding-left: 8px;
        @include fontColorOpacity(.6);
      }
      ul {
        padding: 0;
      }
    }
  }

}
</style>
